import React, { PropsWithChildren, useState } from 'react'
import MFAWrapper from 'mfa-wrapper'
import { Button } from 'foundations-library/components'
import { ErrorDialog } from 'functional-foundations'
import PasswordWidget from './../password-management/index'

/**
 *
 */
export const PostMFASteps = ({ mfaCompleted, mfaFailed, setMfaFailed }: { mfaCompleted: boolean, mfaFailed: boolean, setMfaFailed: (value: boolean) => void }) => {
    if (mfaFailed) return <ErrorDialog isOpen={mfaFailed} title={'MFA failed. Please try again.'} onConfirm={() => setMfaFailed(false)} />
    if (mfaCompleted) return <PasswordWidget openInDialog={true} mfaFlow={true} />
    return null
}

/**
 *
 */
const MFAButton = ({ processPostMFA = true, onClick, children, onSessionOpened, onSessionCompleted, onSessionFailed }: PropsWithChildren<{ processPostMFA?: boolean, onClick?: () => void, onSessionOpened?: () => void, onSessionCompleted?: () => void, onSessionFailed?: () => void }>) => {
    const [mfaCompleted, setMfaCompleted] = useState(false)
    const [mfaFailed, setMfaFailed] = useState(false)
    console.log('MFAButton: mfaCompleted', mfaCompleted)
    return (
        <>
            <MFAWrapper onClick={() => { onClick?.(); setMfaCompleted(false) }} onSessionOpened={onSessionOpened} onSessionCompleted={() => { setMfaCompleted(true); onSessionCompleted?.() }} onSessionFailed={() => { setMfaFailed(true); onSessionFailed?.() }}>
                <Button variant='contained' color='primary' size='large' icon='go' className={'mfa-button'}>
                    {children || 'Enable now'}
                </Button>
            </MFAWrapper>
            {processPostMFA && <PostMFASteps mfaCompleted={mfaCompleted} mfaFailed={mfaFailed} setMfaFailed={setMfaFailed} />}
        </>
    )
}

export default MFAButton
